export default __webpack_public_path__ + "phoenix-logo-icon.svg";